// Mock stock data for fallback and testing purposes
export const mockStocks = [
  { symbol: 'AAPL', price: 150.23, change: 2.50, changePercent: 1.67, volume: 55000000 },
  { symbol: 'GOOGL', price: 2800.75, change: -15.20, changePercent: -0.54, volume: 1800000 },
  { symbol: 'MSFT', price: 290.50, change: 5.75, changePercent: 1.98, volume: 25000000 },
  { symbol: 'AMZN', price: 3300.25, change: -45.50, changePercent: -1.36, volume: 4200000 },
  { symbol: 'META', price: 330.15, change: 8.25, changePercent: 2.50, volume: 15000000 },
  { symbol: 'TSLA', price: 750.80, change: -12.30, changePercent: -1.62, volume: 30000000 },
  { symbol: 'NVDA', price: 280.45, change: 6.80, changePercent: 2.42, volume: 20000000 },
  { symbol: 'JPM', price: 155.90, change: -2.15, changePercent: -1.36, volume: 12000000 },
  { symbol: 'BAC', price: 42.75, change: 0.85, changePercent: 1.95, volume: 45000000 },
  { symbol: 'WMT', price: 145.30, change: 1.20, changePercent: 0.83, volume: 8000000 },
  { symbol: 'DIS', price: 178.90, change: -3.45, changePercent: -1.89, volume: 10000000 },
  { symbol: 'NFLX', price: 525.60, change: 12.80, changePercent: 2.44, volume: 5000000 },
  { symbol: 'INTC', price: 55.40, change: -0.75, changePercent: -1.34, volume: 28000000 },
  { symbol: 'AMD', price: 92.80, change: 3.20, changePercent: 3.45, volume: 42000000 },
  { symbol: 'UBER', price: 45.25, change: 1.15, changePercent: 2.54, volume: 18000000 }
];